import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=108dd446&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=108dd446&prod&scoped=true&lang=css&"
import style1 from "./PersonalInfo.vue?vue&type=style&index=1&id=108dd446&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108dd446",
  null
  
)

export default component.exports